import api from './client';
import type { Documento, Imagem, RespostaListaDocumentos, RespostaListaImagens } from '../types';

// ===== AUTH =====
export const authService = {
  async login(email: string, senha: string): Promise<{ token: string; usuario: any }> {
    const { data } = await api.post('/auth/login', { email, senha });
    return data;
  },
  async logout(): Promise<void> {
    try { await api.post('/auth/logout'); } catch {}
    localStorage.removeItem('licmab_token');
    localStorage.removeItem('licmab_usuario');
  },
};

// ===== DOCUMENTOS PÚBLICOS =====
export const documentoPublicoService = {
  async listar(): Promise<RespostaListaDocumentos> {
    const { data } = await api.get('/documentos/publicos');
    return data;
  },
  async buscarPorId(id: string): Promise<Documento> {
    const { data } = await api.get(`/documentos/publicos/${id}`);
    return data;
  },
  downloadUrl(id: string): string {
    const base = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
    return `${base}/documentos/publicos/${id}/download`;
  },
};

// ===== DOCUMENTOS ADMIN =====
export const documentoAdminService = {
  async listar(params?: {
    pagina?: number;
    limite?: number;
    categoria?: string;
    status?: string;
    busca?: string;
  }): Promise<RespostaListaDocumentos> {
    const { data } = await api.get('/documentos/paginado', { params });
    return data;
  },
  async criar(formData: FormData): Promise<Documento> {
    const { data } = await api.post('/documentos', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },
  async atualizar(id: string, payload: Partial<Documento>): Promise<Documento> {
    const { data } = await api.put(`/documentos/${id}`, payload);
    return data;
  },
  async deletar(id: string): Promise<void> {
    await api.delete(`/documentos/${id}`);
  },
};

// ===== GALERIA PÚBLICA =====
export const galeriaPublicaService = {
  async listar(pagina?: string): Promise<RespostaListaImagens> {
    const params = pagina ? { pagina } : {};
    const { data } = await api.get('/galeria', { params });
    return data;
  },
};

// ===== GALERIA ADMIN =====
export const galeriaAdminService = {
  async listar(pagina?: string): Promise<RespostaListaImagens> {
    const params = pagina ? { pagina } : {};
    const { data } = await api.get('/galeria/admin', { params });
    return data;
  },
  async upload(formData: FormData): Promise<Imagem> {
    const { data } = await api.post('/galeria', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },
  async deletar(id: string): Promise<void> {
    await api.delete(`/galeria/${id}`);
  },
};
